import { useReadPerson } from '@aibees/elephant/hooks';
import {
  SaveRecordAction,
  SaveRecordRequest,
} from '@aibees/elephant/hooks/types';
import { useSaveRecord } from '@aibees/elephant/hooks/use-save-record';
import { ROUTES } from '@aibees/elephant/router';
import { SearchType } from '@aibees/elephant/types';
import { useWorkspace } from '@aibees/shared/workspace';
import { useEffect, useState } from 'react';

export function usePeopleAnalyzeProfile(id: string) {
  const [buttonText, setButtonText] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAnalyzed, setIsAnalyzed] = useState<boolean>(false);
  const { data, isLoading: personLoading, refetch } = useReadPerson(id);

  useEffect(() => {
    setIsAnalyzed(!!data?.revelation?.analysis);
    if (data?.revelation?.analysis) {
      setButtonText('View Report');
    } else if (personLoading) {
      setButtonText('Loading...');
    } else {
      setButtonText('Analyze Profile');
    }
  }, [id, data, personLoading]);

  const workspace = useWorkspace();
  const saveApi = useSaveRecord(SearchType.People);

  const handleAnalysis = () => {
    if (data && isAnalyzed) {
      const peopleUrl = ROUTES.peoplePersonalityAnalysis.replace(
        ':id',
        data.id
      );
      window.open(peopleUrl, '_blank');
      return;
    } else {
      setIsLoading(true);
      setButtonText('Analyzing...');
      const payload: SaveRecordRequest = {
        kind: 'ADD',
        actions: [SaveRecordAction.CONTACT_REVEAL_ANALYSIS],
        ids: [id],
        overwriteOwner: false,
        user: workspace?.user,
        labels: [],
      };

      saveApi
        .mutateAsync(payload)
        .then(() => {
          refetch();
          setIsLoading(false);
          setIsAnalyzed(true);
          setButtonText('View Report');
        })
        .catch((_err) => {
          setIsLoading(false);
        });
    }
  };

  return { handleAnalysis, buttonText, isLoading, isAnalyzed };
}
